/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Authentication API
 * This Authentification API for Kazaar
 * OpenAPI spec version: 1.1.11
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddRoleUser200,
  AddRoleUser404,
  AddRoleUserDto,
  CreateUser201,
  CreateUser400,
  CreateUserDto,
  DeleteRoleUser400,
  DeleteRoleUser404,
  DeleteRoleUserDto,
  DeleteUser404,
  GetCurrentUser200,
  GetUser200,
  GetUser404,
  ListUsers200,
  ListUsersParams,
  SendInviteUser404,
  UpdateUser200,
  UpdateUser400,
  UpdateUser404,
  UpdateUserDto,
  UserEntity
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * List Users
 * @summary List Users
 */
export type listUsersResponse200 = {
  data: ListUsers200
  status: 200
}

export type listUsersResponseSuccess = (listUsersResponse200) & {
  headers: Headers;
};
;

export type listUsersResponse = (listUsersResponseSuccess)

export const getListUsersUrl = (params: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/users?${stringifiedParams}` : `/auth/users`
}

export const listUsers = async (params: ListUsersParams, options?: RequestInit): Promise<listUsersResponse> => {
  
  return customFetch<listUsersResponse>(getListUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/auth/users`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(params: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params: ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create User
 * @summary Create User
 */
export type createUserResponse201 = {
  data: CreateUser201
  status: 201
}

export type createUserResponse400 = {
  data: CreateUser400
  status: 400
}

export type createUserResponseSuccess = (createUserResponse201) & {
  headers: Headers;
};
export type createUserResponseError = (createUserResponse400) & {
  headers: Headers;
};

export type createUserResponse = (createUserResponseSuccess | createUserResponseError)

export const getCreateUserUrl = () => {


  

  return `/auth/users`
}

export const createUser = async (createUserDto: CreateUserDto, options?: RequestInit): Promise<createUserResponse> => {
  
  return customFetch<createUserResponse>(getCreateUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserDto,)
  }
);}
  



export const getCreateUserMutationOptions = <TError = ErrorType<CreateUser400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserDto}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserDto
    export type CreateUserMutationError = ErrorType<CreateUser400>

    /**
 * @summary Create User
 */
export const useCreateUser = <TError = ErrorType<CreateUser400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserDto},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }
    /**
 * Get current User
 * @summary Get current User
 */
export type getCurrentUserResponse200 = {
  data: GetCurrentUser200
  status: 200
}

export type getCurrentUserResponseSuccess = (getCurrentUserResponse200) & {
  headers: Headers;
};
;

export type getCurrentUserResponse = (getCurrentUserResponseSuccess)

export const getGetCurrentUserUrl = () => {


  

  return `/auth/users/me`
}

export const getCurrentUser = async ( options?: RequestInit): Promise<getCurrentUserResponse> => {
  
  return customFetch<getCurrentUserResponse>(getGetCurrentUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCurrentUserQueryKey = () => {
    return [
    `/auth/users/me`
    ] as const;
    }

    
export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = ErrorType<unknown>


export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current User
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Get User
 * @summary Get User
 */
export type getUserResponse200 = {
  data: GetUser200
  status: 200
}

export type getUserResponse404 = {
  data: GetUser404
  status: 404
}

export type getUserResponseSuccess = (getUserResponse200) & {
  headers: Headers;
};
export type getUserResponseError = (getUserResponse404) & {
  headers: Headers;
};

export type getUserResponse = (getUserResponseSuccess | getUserResponseError)

export const getGetUserUrl = (id: string,) => {


  

  return `/auth/users/${id}`
}

export const getUser = async (id: string, options?: RequestInit): Promise<getUserResponse> => {
  
  return customFetch<getUserResponse>(getGetUserUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserQueryKey = (id: string,) => {
    return [
    `/auth/users/${id}`
    ] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<GetUser404>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<GetUser404>


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<GetUser404>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<GetUser404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<GetUser404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<GetUser404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update User
 * @summary Update User
 */
export type updateUserResponse200 = {
  data: UpdateUser200
  status: 200
}

export type updateUserResponse400 = {
  data: UpdateUser400
  status: 400
}

export type updateUserResponse404 = {
  data: UpdateUser404
  status: 404
}

export type updateUserResponseSuccess = (updateUserResponse200) & {
  headers: Headers;
};
export type updateUserResponseError = (updateUserResponse400 | updateUserResponse404) & {
  headers: Headers;
};

export type updateUserResponse = (updateUserResponseSuccess | updateUserResponseError)

export const getUpdateUserUrl = (id: string,) => {


  

  return `/auth/users/${id}`
}

export const updateUser = async (id: string,
    updateUserDto: UpdateUserDto, options?: RequestInit): Promise<updateUserResponse> => {
  
  return customFetch<updateUserResponse>(getUpdateUserUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserDto,)
  }
);}
  



export const getUpdateUserMutationOptions = <TError = ErrorType<UpdateUser400 | UpdateUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: string;data: UpdateUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserDto
    export type UpdateUserMutationError = ErrorType<UpdateUser400 | UpdateUser404>

    /**
 * @summary Update User
 */
export const useUpdateUser = <TError = ErrorType<UpdateUser400 | UpdateUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: string;data: UpdateUserDto},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }
    /**
 * Delete User
 * @summary Delete User
 */
export type deleteUserResponse204 = {
  data: void
  status: 204
}

export type deleteUserResponse404 = {
  data: DeleteUser404
  status: 404
}

export type deleteUserResponseSuccess = (deleteUserResponse204) & {
  headers: Headers;
};
export type deleteUserResponseError = (deleteUserResponse404) & {
  headers: Headers;
};

export type deleteUserResponse = (deleteUserResponseSuccess | deleteUserResponseError)

export const getDeleteUserUrl = (id: string,) => {


  

  return `/auth/users/${id}`
}

export const deleteUser = async (id: string, options?: RequestInit): Promise<deleteUserResponse> => {
  
  return customFetch<deleteUserResponse>(getDeleteUserUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteUserMutationOptions = <TError = ErrorType<DeleteUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = ErrorType<DeleteUser404>

    /**
 * @summary Delete User
 */
export const useDeleteUser = <TError = ErrorType<DeleteUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }
    /**
 * Add role to User
 * @summary Add role to User
 */
export type addRoleUserResponse200 = {
  data: AddRoleUser200
  status: 200
}

export type addRoleUserResponse404 = {
  data: AddRoleUser404
  status: 404
}

export type addRoleUserResponseSuccess = (addRoleUserResponse200) & {
  headers: Headers;
};
export type addRoleUserResponseError = (addRoleUserResponse404) & {
  headers: Headers;
};

export type addRoleUserResponse = (addRoleUserResponseSuccess | addRoleUserResponseError)

export const getAddRoleUserUrl = (id: string,) => {


  

  return `/auth/users/${id}/roles`
}

export const addRoleUser = async (id: string,
    addRoleUserDto: AddRoleUserDto, options?: RequestInit): Promise<addRoleUserResponse> => {
  
  return customFetch<addRoleUserResponse>(getAddRoleUserUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addRoleUserDto,)
  }
);}
  



export const getAddRoleUserMutationOptions = <TError = ErrorType<AddRoleUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRoleUser>>, TError,{id: string;data: AddRoleUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addRoleUser>>, TError,{id: string;data: AddRoleUserDto}, TContext> => {

const mutationKey = ['addRoleUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRoleUser>>, {id: string;data: AddRoleUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  addRoleUser(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AddRoleUserMutationResult = NonNullable<Awaited<ReturnType<typeof addRoleUser>>>
    export type AddRoleUserMutationBody = AddRoleUserDto
    export type AddRoleUserMutationError = ErrorType<AddRoleUser404>

    /**
 * @summary Add role to User
 */
export const useAddRoleUser = <TError = ErrorType<AddRoleUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRoleUser>>, TError,{id: string;data: AddRoleUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addRoleUser>>,
        TError,
        {id: string;data: AddRoleUserDto},
        TContext
      > => {
      return useMutation(getAddRoleUserMutationOptions(options), queryClient);
    }
    /**
 * Delete role to User
 * @summary Delete role to User
 */
export type deleteRoleUserResponse200 = {
  data: UserEntity
  status: 200
}

export type deleteRoleUserResponse400 = {
  data: DeleteRoleUser400
  status: 400
}

export type deleteRoleUserResponse404 = {
  data: DeleteRoleUser404
  status: 404
}

export type deleteRoleUserResponseSuccess = (deleteRoleUserResponse200) & {
  headers: Headers;
};
export type deleteRoleUserResponseError = (deleteRoleUserResponse400 | deleteRoleUserResponse404) & {
  headers: Headers;
};

export type deleteRoleUserResponse = (deleteRoleUserResponseSuccess | deleteRoleUserResponseError)

export const getDeleteRoleUserUrl = (id: string,) => {


  

  return `/auth/users/${id}/roles`
}

export const deleteRoleUser = async (id: string,
    deleteRoleUserDto: DeleteRoleUserDto, options?: RequestInit): Promise<deleteRoleUserResponse> => {
  
  return customFetch<deleteRoleUserResponse>(getDeleteRoleUserUrl(id),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteRoleUserDto,)
  }
);}
  



export const getDeleteRoleUserMutationOptions = <TError = ErrorType<DeleteRoleUser400 | DeleteRoleUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoleUser>>, TError,{id: string;data: DeleteRoleUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoleUser>>, TError,{id: string;data: DeleteRoleUserDto}, TContext> => {

const mutationKey = ['deleteRoleUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoleUser>>, {id: string;data: DeleteRoleUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  deleteRoleUser(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoleUser>>>
    export type DeleteRoleUserMutationBody = DeleteRoleUserDto
    export type DeleteRoleUserMutationError = ErrorType<DeleteRoleUser400 | DeleteRoleUser404>

    /**
 * @summary Delete role to User
 */
export const useDeleteRoleUser = <TError = ErrorType<DeleteRoleUser400 | DeleteRoleUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoleUser>>, TError,{id: string;data: DeleteRoleUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoleUser>>,
        TError,
        {id: string;data: DeleteRoleUserDto},
        TContext
      > => {
      return useMutation(getDeleteRoleUserMutationOptions(options), queryClient);
    }
    /**
 * Sends an invitation email with password reset link to the specified user
 * @summary Send invitation email to user
 */
export type sendInviteUserResponse204 = {
  data: void
  status: 204
}

export type sendInviteUserResponse404 = {
  data: SendInviteUser404
  status: 404
}

export type sendInviteUserResponseSuccess = (sendInviteUserResponse204) & {
  headers: Headers;
};
export type sendInviteUserResponseError = (sendInviteUserResponse404) & {
  headers: Headers;
};

export type sendInviteUserResponse = (sendInviteUserResponseSuccess | sendInviteUserResponseError)

export const getSendInviteUserUrl = (id: string,) => {


  

  return `/auth/users/${id}/send-invite`
}

export const sendInviteUser = async (id: string, options?: RequestInit): Promise<sendInviteUserResponse> => {
  
  return customFetch<sendInviteUserResponse>(getSendInviteUserUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getSendInviteUserMutationOptions = <TError = ErrorType<SendInviteUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInviteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendInviteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['sendInviteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInviteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sendInviteUser(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SendInviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof sendInviteUser>>>
    
    export type SendInviteUserMutationError = ErrorType<SendInviteUser404>

    /**
 * @summary Send invitation email to user
 */
export const useSendInviteUser = <TError = ErrorType<SendInviteUser404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInviteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInviteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSendInviteUserMutationOptions(options), queryClient);
    }
    